import { useEffect } from "react";
import { trackEvent } from "../api/reviewApi";
import { getQrTrackedTokens, markQrTracked } from "../utils/session";

export const useQrTracking = (token, isValidToken) => {
  useEffect(() => {
    if (!token || !isValidToken) return;

    let isMounted = true;

    const trackQrScan = async () => {
      const trackedTokens = getQrTrackedTokens();
      if (trackedTokens[token]) return;

      markQrTracked(token);

      try {
        await trackEvent({ eventType: "QR_SCAN", source: "QR" }, token);
        console.log("QR tracked successfully");
      } catch (err) {
        console.error("QR tracking failed:", err);
        if (!isMounted) return;

        const tokens = getQrTrackedTokens();
        delete tokens[token];
        localStorage.setItem("qr_tracked_tokens", JSON.stringify(tokens));
      }
    };

    trackQrScan();
    return () => { isMounted = false; };
  }, [token, isValidToken]);
};